import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface AddGenericNameModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (genericName: string) => void;
  onCancel: () => void;
  trigger: React.ReactNode;
}

const AddGenericNameModal: React.FC<AddGenericNameModalProps> = ({
  open,
  onOpenChange,
  onSave,
  onCancel,
  trigger,
}) => {
  const [genericName, setGenericName] = useState("");

  const handleSave = () => {
    if (genericName.trim()) {
      onSave(genericName.trim());
      setGenericName("");
    }
  };

  const handleCancel = () => {
    setGenericName("");
    onCancel();
  };

  return (
    <>
      {trigger}
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="text-black">
          <DialogHeader>
            <DialogTitle>Add Generic Name</DialogTitle>
          </DialogHeader>
          <Input
            value={genericName}
            onChange={(e) => setGenericName(e.target.value)}
            placeholder="Enter generic name"
            autoFocus
          />
          <DialogFooter className="mt-4 flex gap-2 justify-end">
            <DialogClose asChild>
              <Button variant="outline" onClick={handleCancel}>
                Cancel
              </Button>
            </DialogClose>
            <Button onClick={handleSave} disabled={!genericName.trim()}>
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddGenericNameModal;
